// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2Z8F-","upload":"Small_upload__S2y-h","imageWrap":"Small_imageWrap__1LxRY","removeBtn":"Small_removeBtn__2xcVE"};